import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';

const navLinks = [
  { label: 'Home', to: '/' },
  { label: 'Services', to: '/services' },
  { label: 'About Us', to: '/about-us' },
  { label: 'Locations', to: '/locations' },
];

const Header = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    setIsMobileMenuOpen(false);
  }, [location]);

  const isHomePage = location.pathname === '/';
  const solidBg = isScrolled || !isHomePage;

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        solidBg ? 'bg-white shadow-md' : 'bg-transparent'
      }`}
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center h-20">
          {/* Logo */}
          <Link to="/" className="flex-shrink-0">
            <img
              src="https://lirp.cdn-website.com/87c1be40/dms3rep/multi/opt/logo-1920w.png"
              alt="Custom Clothiers"
              className="h-12 w-auto"
            />
          </Link>

          {/* Desktop Navigation */}
          <nav className="hidden lg:flex items-center space-x-10">
            {navLinks.map((link) => {
              const isActive = location.pathname === link.to;
              return (
                <Link
                  key={link.to}
                  to={link.to}
                  className={`text-sm font-semibold transition-colors whitespace-nowrap border-b-2 pb-0.5 ${
                    isActive
                      ? 'text-[#C4A962] border-[#C4A962]'
                      : `border-transparent hover:text-[#C4A962] hover:border-[#C4A962] ${
                          solidBg ? 'text-gray-900' : 'text-white'
                        }`
                  }`}
                >
                  {link.label}
                </Link>
              );
            })}
          </nav>

          {/* CTA */}
          <div className="hidden lg:flex items-center space-x-4">
            <a
              href="tel:781-237-3166"
              className={`text-sm font-semibold transition-colors hover:text-[#C4A962] whitespace-nowrap ${
                solidBg ? 'text-gray-900' : 'text-white'
              }`}
            >
              <i className="ri-phone-line mr-1"></i>
              781-237-3166
            </a>
            <Link
              to="/contact"
              className="bg-[#C4A962] text-white px-6 py-2.5 rounded-lg text-sm font-semibold hover:bg-[#B39952] transition-colors whitespace-nowrap"
            >
              Book Consultation
            </Link>
          </div>

          {/* Mobile Toggle */}
          <button
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
            className={`lg:hidden p-2 rounded-md transition-colors cursor-pointer ${
              solidBg ? 'text-gray-900' : 'text-white'
            }`}
            aria-label="Toggle menu"
          >
            <i className={`text-2xl ${isMobileMenuOpen ? 'ri-close-line' : 'ri-menu-line'}`}></i>
          </button>
        </div>
      </div>

      {/* Mobile Menu */}
      {isMobileMenuOpen && (
        <div className="lg:hidden bg-white border-t border-gray-200">
          <div className="px-4 py-6 space-y-5">
            {navLinks.map((link) => (
              <Link
                key={link.to}
                to={link.to}
                className={`block font-semibold transition-colors ${
                  location.pathname === link.to
                    ? 'text-[#C4A962]'
                    : 'text-gray-900 hover:text-[#C4A962]'
                }`}
              >
                {link.label}
              </Link>
            ))}
            <a
              href="tel:781-237-3166"
              className="block text-gray-900 font-semibold hover:text-[#C4A962] transition-colors"
            >
              <i className="ri-phone-line mr-2"></i>781-237-3166
            </a>
            <Link
              to="/contact"
              className="block bg-[#C4A962] text-white px-6 py-3 rounded-lg text-center font-semibold hover:bg-[#B39952] transition-colors whitespace-nowrap"
            >
              Book Consultation
            </Link>
          </div>
        </div>
      )}
    </header>
  );
};

export default Header;
